import type { MouseEvent, RefObject } from 'react'

import copyJson from '../../demo/fixtures/w3/copy.json'
import rulesJson from '../../demo/fixtures/w3/rules.json'
import type { Optimization, OptimizationType } from '../../demo/types'
import { Button, TimelineItem } from '../../ui'
import styles from './AutopilotSection.module.css'

interface CopyFixture { moreLog: string }
interface RulesFixture { defaultExpanded: number }

const copy = copyJson as unknown as CopyFixture
const rules = rulesJson as unknown as RulesFixture

export type AnalysisTargets = Partial<Record<Exclude<OptimizationType, 'needs_human'>, RefObject<HTMLElement | null>>>

interface AutopilotLogProps {
  items: Optimization[]
  visibleIds: Set<string> | null
  animateIds: Set<string>
  expanded: boolean
  audienceEdited: boolean
  targets: AnalysisTargets
  onExpandedChange: (value: boolean) => void
  onUndo: (id: string) => void
  onGo: (target: string) => void
}

export function AutopilotLog({ items, visibleIds, animateIds, expanded, audienceEdited, targets, onExpandedChange, onUndo, onGo }: AutopilotLogProps) {
  const revealed = visibleIds ? items.filter((item) => visibleIds.has(item.id)) : items
  const shown = expanded ? revealed : revealed.slice(0, rules.defaultExpanded)
  const latestAudienceId = items.find((item) => item.type === 'audience' && !item.undone)?.id

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement
    if (target.closest('button')) return
    const row = target.closest<HTMLElement>('[data-op]')
    if (!row) return
    const item = items.find((candidate) => candidate.id === row.dataset.op)
    if (!item || item.type === 'needs_human') return
    targets[item.type]?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  return (
    <>
      <div className={styles.timeline} data-scope="ap-log" onClick={handleClick}>
        {shown.map((item) => <div className={`${styles.logRow} ${animateIds.has(item.id) ? styles.logFadeIn : ''}`} key={item.id}>
          <TimelineItem item={item} onUndo={!item.undone && item.payload != null ? onUndo : undefined} onGo={onGo} />
          {audienceEdited && item.id === latestAudienceId ? <p className={styles.audienceEdited}>你之后手动改过这里</p> : null}
        </div>)}
      </div>
      {revealed.length > rules.defaultExpanded ? <Button variant="link" className={styles.moreLog} onClick={() => onExpandedChange(!expanded)}>{expanded ? '收起优化记录 ↑' : copy.moreLog.replace('{n}', String(items.length))}</Button> : null}
    </>
  )
}
